import "../../index.css";
import { CharteredFirmPageScreen } from "./chartered-firm-page-screen.tsx";
import { reactHydrate } from "../../react-hydrate.ts";

window.Components = {
  CharteredFirmPageScreen: CharteredFirmPageScreen,
};

reactHydrate();
